import 'core-js/stable';
import 'regenerator-runtime/runtime';


// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');

// Bootstrap - The most popular framework uses as the foundation. Learn more: http://getbootstrap.com
require('bootstrap');

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
window.Popper = require('popper.js').default;

// Wnumb - Number & Money formatting. Learn more: npm i wnumb
window.wNumb = require('wnumb');

// Moment - Parse, validate, manipulate, and display dates and times in JavaScript. Learn more: https://momentjs.com/
window.moment = require('moment');

// ES6-Shim - ECMAScript 6 compatibility shims for legacy JS engines.  Learn more: https://github.com/paulmillr/es6-shim
require("es6-shim/es6-shim.min.js");

// Perfect-Scrollbar - Minimalistic but perfect custom scrollbar plugin.  Learn more:  https://github.com/mdbootstrap/perfect-scrollbar
window.PerfectScrollbar = require('perfect-scrollbar/dist/perfect-scrollbar');

// Bootstrap Notify - This plugin helps to turn standard bootstrap alerts into "growl" like notifications: http://bootstrap-notify.remabledesigns.com/
require('bootstrap-notify/bootstrap-notify.min.js');
require('@/m-js/vendors/plugins/bootstrap-notify.init.js');

// Bootstrap Datepicker - Bootstrap-datepicker provides a flexible datepicker widget in the Bootstrap style: https://bootstrap-datepicker.readthedocs.io/en/latest/
require('bootstrap-datepicker/dist/js/bootstrap-datepicker.js');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.sk.min');

// Summernote - Super Simple WYSIWYG Editor on Bootstrap Summernote is a JavaScript library that helps you create WYSIWYG editors online: https://summernote.org/
require('summernote/dist/summernote.js');
// require('summernote/dist/lang/summernote-ru-RU.min');

// Импортруем datatable без jquery и его бутстрап версию
require('datatables.net-dt/js/dataTables.dataTables.min.js');
require('datatables.net-bs4/js/dataTables.bootstrap4.js');
import jszip from 'jszip'
require('datatables.net-buttons/js/dataTables.buttons.min.js');
require('datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-responsive/js/dataTables.responsive.min.js');
require('datatables.net-responsive-bs4/js/responsive.bootstrap4.min.js');
require('datatables.net-rowreorder/js/dataTables.rowReorder.min.js');

window.JSZip = jszip;

// Bootstrap Select - The jQuery plugin that brings select elements into the 21st century with intuitive multiselection, searching, and much more: https://developer.snapappointments.com/bootstrap-select/
require('bootstrap-select/dist/js/bootstrap-select.js');

// Bootstrap Timepicker - Easily select a time for a text input using your mouse or keyboards arrow keys: https://jdewit.github.io/bootstrap-timepicker/
require('bootstrap-timepicker/js/bootstrap-timepicker.js');
require('@/m-js/vendors/plugins/bootstrap-timepicker.init.js');

//Date Range Picker - A JavaScript component for choosing date ranges, dates and times: https://www.daterangepicker.com/
require('bootstrap-daterangepicker/daterangepicker.js');

// intlTelInput
import intlTelInput from 'intl-tel-input'
window.intlTelInput = intlTelInput;

//LightBox
import 'lightbox2/dist/js/lightbox.min'

// The autosize - function accepts a single textarea element, or an array or array-like object (such as a NodeList or jQuery collection) of textarea elements: https://www.jacklmoore.com/autosize/
window.autosize = require('autosize/dist/autosize.js');

//ClipboardJS
window.ClipboardJS = require('clipboard/dist/clipboard.min.js');

// Toastr - is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended: https://github.com/CodeSeven/toastr
window.toastr = require('toastr/build/toastr.min.js');

window.toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": false,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "2000",
    "extendedTimeOut": "1000",
    // "showEasing": "linear",
    // "hideEasing": "linear",
    // "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};

require('@/m-js/vendors/soundmeter.js');

window.Swal = window.swal = require('sweetalert2/dist/sweetalert2.min.js');
window.axios = require('axios');
window.KTAppSettings = {
    "breakpoints": {
        "sm": 576,
        "md": 768,
        "lg": 992,
        "xl": 1200,
        "xxl": 1200
    },
    "colors": {
        "theme": {
            "base": {
                "white": "#ffffff",
                "primary": "#6993FF",
                "secondary": "#E5EAEE",
                "success": "#1BC5BD",
                "info": "#8950FC",
                "warning": "#FFA800",
                "danger": "#F64E60",
                "light": "#F3F6F9",
                "dark": "#212121"
            },
            "light": {
                "white": "#ffffff",
                "primary": "#E1E9FF",
                "secondary": "#ECF0F3",
                "success": "#C9F7F5",
                "info": "#EEE5FF",
                "warning": "#FFF4DE",
                "danger": "#FFE2E5",
                "light": "#F3F6F9",
                "dark": "#D6D6E0"
            },
            "inverse": {
                "white": "#ffffff",
                "primary": "#ffffff",
                "secondary": "#212121",
                "success": "#ffffff",
                "info": "#ffffff",
                "warning": "#ffffff",
                "danger": "#ffffff",
                "light": "#464E5F",
                "dark": "#ffffff"
            }
        },
        "gray": {
            "gray-100": "#F3F6F9",
            "gray-200": "#ECF0F3",
            "gray-300": "#E5EAEE",
            "gray-400": "#D6D6E0",
            "gray-500": "#B5B5C3",
            "gray-600": "#80808F",
            "gray-700": "#464E5F",
            "gray-800": "#1B283F",
            "gray-900": "#212121"
        }
    },
    "font-family": "Poppins"
};

// Keenthemes' plugins
window.KTUtil = require('@/m-js/components/util.js');
window.KTApp = require('@/m-js/components/app.js');
window.KTCard = require('@/m-js/components/card.js');
window.KTCookie = require('@/m-js/components/cookie.js');
window.KTDialog = require('@/m-js/components/dialog.js');
window.KTHeader = require('@/m-js/components/header.js');
window.KTImageInput = require('@/m-js/components/image-input.js');
window.KTMenu = require('@/m-js/components/menu.js');
window.KTOffcanvas = require('@/m-js/components/offcanvas.js');
window.KTScrolltop = require('@/m-js/components/scrolltop.js');
window.KTToggle = require('@/m-js/components/toggle.js');
window.KTWizard = require('@/m-js/components/wizard.js');
// require('@/m-js/components/datatable/core.datatable.js');
// require('@/m-js/components/datatable/datatable.checkbox.js');
// require('@/m-js/components/datatable/datatable.rtl.js');

// Metronic layout base js
window.KTLayoutAside = require('@/m-js/layout/base/aside.js');
window.KTLayoutAsideMenu = require('@/m-js/layout/base/aside-menu.js');
window.KTLayoutContent = require('@/m-js/layout/base/content.js');
window.KTLayoutFooter = require('@/m-js/layout/base/footer.js');
window.KTLayoutHeader = require('@/m-js/layout/base/header.js');
window.KTLayoutHeaderMenu = require('@/m-js/layout/base/header-menu.js');
window.KTLayoutHeaderTopbar = require('@/m-js/layout/base/header-topbar.js');
window.KTLayoutStickyCard = require('@/m-js/layout/base/sticky-card.js');
window.KTLayoutStretchedCard = require('@/m-js/layout/base/stretched-card.js');
window.KTLayoutSubheader = require('@/m-js/layout/base/subheader.js');

// Metronic layout extended js
window.KTLayoutChat = require('@/m-js/layout/extended/chat.js');
window.KTLayoutDemoPanel = require('@/m-js/layout/extended/demo-panel.js');
window.KTLayoutExamples = require('@/m-js/layout/extended/examples.js');
window.KTLayoutQuickActions = require('@/m-js/layout/extended/quick-actions.js');
window.KTLayoutQuickCartPanel = require('@/m-js/layout/extended/quick-cart.js');
window.KTLayoutQuickNotifications = require('@/m-js/layout/extended/quick-notifications.js');
window.KTLayoutQuickPanel = require('@/m-js/layout/extended/quick-panel.js');
window.KTLayoutQuickSearch = require('@/m-js/layout/extended/quick-search.js');
window.KTLayoutQuickUser = require('@/m-js/layout/extended/quick-user.js');
window.KTLayoutScrolltop = require('@/m-js/layout/extended/scrolltop.js');
window.KTLayoutSearch = window.KTLayoutSearchOffcanvas = require('@/m-js/layout/extended/search.js');







